import React from 'react'
import ReactDOM from 'react-dom/client'
import ThemeProvider from './theme/ThemeProvider'
import App from './App'
import { initSentry, ErrorBoundary } from './observability/sentry'
import ErrorFallback from './components/ErrorFallback'

initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ErrorBoundary
        fallback={({ error, resetError }) => (
          <ErrorFallback error={error} resetError={resetError} />
        )}
      >
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
)
